// app/javascript/controllers/collapse_controller.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.toggleClass = "hidden";
  }

  toggle(event) {
    const header = event.currentTarget;
    const content = header.nextElementSibling;
    content.classList.toggle(this.toggleClass);
  }
}
